<div
  class="group flex gap-1 rounded-xl p-1 transition-colors select-none"
  [class.h-full]="fullHeight()"
  [class.h-max]="!fullHeight()"
  [class.w-full]="fullWidth()"
  [class.w-max]="!fullWidth()"
  [class.min-w-64]="!fullWidth()"
  [class.flex-col]="layout() === 'VERTICAL'"
  [class.flex-row]="layout() === 'HORIZONTAL'"
  [class]="twBackground()"
  [attr.role]="isClickable() ? 'button' : null"
  [attr.tabindex]="isClickable() ? 0 : null"
  (click)="isClickable() ? clicked.emit() : undefined"
  (keydown.enter)="isClickable() ? clicked.emit() : undefined"
  (keydown.space)="$event.preventDefault(); isClickable() ? clicked.emit() : undefined"
>
  @if (image(); as image) {
    <img
      [src]="image"
      [alt]="text()"
      class="w-3xs rounded-lg object-cover transition-colors select-none xl:w-xs"
      [class]="{
        grayscale: state() === 'DISABLED',
        'h-full': layout() === 'VERTICAL',
        'self-stretch': layout() === 'HORIZONTAL',
      }"
      (dragstart)="(false)"
    />
  }

  @if (audio(); as audio) {
    <div
      class="font-default grid w-full place-content-center rounded-lg p-2 text-center text-4xl font-normal transition-colors"
      [class]="{
        'h-full': layout() === 'VERTICAL',
        'self-stretch': layout() === 'HORIZONTAL',
        'bg-card-background': state() === 'DEFAULT',
        'bg-slate-100': state() === 'DISABLED',
        'bg-red-100': state() === 'INCORRECT',
        'bg-emerald-100': state() === 'CORRECT',
        'text-emerald-500': state() === 'CORRECT',
        'text-red-500': state() === 'INCORRECT',
        'text-text-primary': state() === 'DEFAULT',
        'text-slate-300': state() === 'DISABLED',
        'group-hover:text-blue-500': isClickable() && state() === 'DEFAULT',
      }"
    >
      <rid-audio-button #audioButton [src]="audio" [size]="image() ? 'SMALL' : 'XSMALL'" />
    </div>
  }

  @if (text(); as text) {
    <div
      #contentCardText
      class="font-default relative grid w-full place-content-center place-items-center rounded-lg p-4 text-4xl font-normal transition-colors"
      [class]="{
        'h-full': layout() === 'VERTICAL',
        'self-stretch': layout() === 'HORIZONTAL',
        'bg-card-background': state() === 'DEFAULT',
        'bg-slate-100': state() === 'DISABLED',
        'bg-red-100': state() === 'INCORRECT',
        'bg-emerald-100': state() === 'CORRECT',
        'text-emerald-500': state() === 'CORRECT',
        'text-red-500': state() === 'INCORRECT',
        'text-text-primary': state() === 'DEFAULT',
        'text-slate-300': state() === 'DISABLED',
        'group-hover:text-blue-500': isClickable() && state() === 'DEFAULT',
      }"
    >
      @if (autoSizeText()) {
        <div class="absolute inset-x-4 text-center" [class]="autoTextSizeClass()">
          {{ text }}
        </div>
      } @else {
        {{ text }}
      }
    </div>
  }
</div>
